export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manaup.27be59c4.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};